import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, CartesianGrid } from 'recharts';

interface DFCLinha {
  realizado: number;
  previsto: number;
}

interface Props {
  consolidado: Record<string, Record<string, DFCLinha>>;
  periodos: string[];
  linha?: string;
}

const fmt = (v: number) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 }).format(v);

export function GraficoDFC({ consolidado, periodos, linha = 'recebimento' }: Props) {
  const dados = periodos.map((p) => ({
    periodo: p,
    Realizado: consolidado[p]?.[linha]?.realizado ?? 0,
    Orçado: consolidado[p]?.[linha]?.previsto ?? 0,
  }));

  return (
    <div style={styles.wrapper}>
      <h3 style={styles.titulo}>{linha.replace(/_/g, ' ').toUpperCase()} — Realizado vs Orçado</h3>
      <ResponsiveContainer width="100%" height={280}>
        <BarChart data={dados} margin={{ top: 8, right: 16, left: 16, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#2d3347" />
          <XAxis dataKey="periodo" tick={{ fill: '#94a3b8', fontSize: 11 }} />
          <YAxis tickFormatter={(v) => `R$${(v / 1000).toFixed(0)}k`} tick={{ fill: '#94a3b8', fontSize: 11 }} />
          <Tooltip
            formatter={(v: number) => fmt(v)}
            contentStyle={{ background: '#1e2130', border: '1px solid #2d3347', borderRadius: 8 }}
            labelStyle={{ color: '#94a3b8' }}
          />
          <Legend wrapperStyle={{ color: '#94a3b8', fontSize: 12 }} />
          <Bar dataKey="Realizado" fill="#2D73F5" radius={[4, 4, 0, 0]} />
          <Bar dataKey="Orçado" fill="#48d951" radius={[4, 4, 0, 0]} opacity={0.6} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  wrapper: {
    background: '#1e2130',
    borderRadius: 12,
    padding: 24,
    color: '#e2e8f0',
    fontFamily: 'Inter, system-ui, sans-serif',
  },
  titulo: { margin: '0 0 20px', fontSize: 14, fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase' },
};
